import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Match from '../../utilities/validation'
import { Link } from 'react-router-dom'
import {
    invalidEmail,
    invalidPass,
    emptyEmail,
    newPassword,
    emptyPassword,
    confirmPassword,
    confirmPasswordNew,
    invalid6,
    invalid7,
    invalid8,
    passMatch,
    currentPassword,
    invalid2,
    invalid4,
    invalid5,
    invalid3,
} from '../../utilities/message'
import { Modal } from '@mui/material'
import ModalClose from '@mui/joy/ModalClose'

import { resetPassword } from '../../actions/user'
import Loader from '../../components/Loader'
import { blue } from '@mui/material/colors'
import { changePasswordSubAdmin } from '../../actions/admin'
import { lastLogin, logout_user } from '../../actions/user'
import {
    userListing,
    deleteUsers,
    getMerchantProfile,
    editMerchant,
    updateSelectedMerchantId,
} from '../../actions/merchant'

const ChangePassword = () => {
    const loaders = useSelector((state) => state.loader)
    const [openModal, setModal] = useState(false)
    const [pass, setPass] = useState(true)
    const [pass2, setPass2] = useState(true)
    const [openCongrModal, setOpenCongrModal] = useState(false)

    const [changepass, setChangePass] = useState(true)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const [passVal, setPassVal] = useState('')
    const [passVal2, setPassVal2] = useState()

    const passInputVal = (event) => {
        setPassVal2(event.target.value.replace(/\s/g, ''))
    }

    const handleChangeForm = (values) => {
        if (
            values.password &&
            values.passwordConfirmation &&
            values.password.trim() === values.passwordConfirmation.trim()
        ) {
            setError(null)
        } else {
            if (values.passwordConfirmation && values.passwordConfirmation != ' ') {
                setError(passMatch)
            } else {
                setError(null)
            }
        }
    }

    const submitForgot = (values) => {
        if (values.password.trim() === values.passwordConfirmation.trim()) {
            dispatch(
                changePasswordSubAdmin({ ...values }, (res) => {
                    if (res) {
                        setOpenCongrModal(true);
                        setTimeout(() => {
                            dispatch(lastLogin(false))
                            dispatch(logout_user())
                            setOpenCongrModal(false);
                        }, [6000])

                        setError(null);
                    }
                })
            );
        } else {
            setError(passMatch)
        }
    }
    const handleChange = (e) => {
        e.preventDefault()
    }

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    useEffect(() => {
        if (user.data.roles == 'merchant') {
            let params = {};
            params.merchant_id = user?.data?.merchantData.id;
            dispatch(getMerchantProfile(params, (res) => { }));
        }
    }, [])

    return (
        <div>
            <Loader loading={loaders.isFetching} />
            <div style={{ display: 'flex' }}>
                <div>
                    <p className="headinguser">Security/Password</p>
                    <p className="subheadinggraph">Configure Password</p>
                </div>
            </div>

            <div>
                <LocalForm
                    model="user"
                    onSubmit={(values) => submitForgot(values)}
                    onChange={(values) => handleChangeForm(values)}
                >
                    <div className="passTab1">
                        <div className="passDiv">
                            <div class="mb-3">
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                    }}
                                >
                                    <Control.text
                                        model="user.currentPassword"
                                        className="form-control input-field password"
                                        id="user.currentPassword"
                                        value={passVal2}
                                        onChange={(e) => passInputVal(e)}
                                        onPaste={(e) => handleChange(e)}
                                        onCopy={(e) => handleChange(e)}
                                        type={pass2 ? 'password' : 'text'}
                                        placeholder="Current Password"
                                        errors={{
                                            currentPassword: (val) => !val,
                                            // invalidPass: (val) => val && val.length < 5
                                        }}
                                    ></Control.text>
                                    {pass2 && (
                                        <i class="  iconeye" onClick={() => setPass2(false)}>
                                            <img
                                                src={require('../../assets/images/eye-slash.png')}
                                            />
                                        </i>
                                    )}

                                    {!pass2 && (
                                        <i class="  iconeye" onClick={() => setPass2(true)}>
                                            <img src={require('../../assets/images/eye.png')} />
                                        </i>
                                    )}
                                </div>
                                <Errors
                                    model="user.currentPassword"
                                    errors={{
                                        currentPassword,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="passTab1">
                        <div className="newPassDiv">
                            <div class="mb-3">
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                    }}
                                >
                                    <Control.text
                                        model="user.password"
                                        className="form-control input-field password"
                                        id="user.password"
                                        value={passVal}
                                        maxLength={20}
                                        type={pass ? 'password' : 'text'}
                                        onChange={(e) => setPassVal(e.target.value)}
                                        placeholder="New Password"
                                        onPaste={(e) => handleChange(e)}
                                        onCopy={(e) => handleChange(e)}
                                        errors={{
                                            newPassword: (val) => !val,
                                            invalidPass: (val) =>
                                                val && !Match.validatePassword(val),
                                            invalid2: (val) => val && !Match.validatePassword(val),
                                            invalid3: (val) => val && !Match.validatePassword(val),
                                            invalid4: (val) => val && !Match.validatePassword(val),
                                            invalid5: (val) => val && !Match.validatePassword(val),
                                            invalid6: (val) => val && !Match.validatePassword(val),
                                            invalid7: (val) => val && !Match.validatePassword(val),
                                        }}
                                    ></Control.text>

                                    {pass && (
                                        <i class=" iconeye" onClick={() => setPass(false)}>
                                            <img
                                                src={require('../../assets/images/eye-slash.png')}
                                            />
                                        </i>
                                    )}

                                    {!pass && (
                                        <i class=" iconeye" onClick={() => setPass(true)}>
                                            <img src={require('../../assets/images/eye.png')} />
                                        </i>
                                    )}
                                </div>
                                <Errors
                                    model="user.password"
                                    style={{ width: '408px' }}
                                    errors={{
                                        newPassword,
                                        invalidPass,
                                        invalid2,
                                        invalid3,
                                        invalid4,
                                        invalid5,
                                        invalid6,
                                        invalid7,
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="confirmPassDiv">
                        <div class="mb-3">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                }}
                            >
                                <Control.text
                                    model="user.passwordConfirmation"
                                    className="form-control input-field password"
                                    id="user.passwordConfirmation"
                                    maxLength={20}
                                    type={changepass ? 'password' : 'text'}
                                    placeholder="Confirm Password"
                                    onPaste={(e) => handleChange(e)}
                                    onCopy={(e) => handleChange(e)}
                                    errors={{
                                        confirmPasswordNew: (val) => !val,
                                        // confirmPassword:(val) => val &&  val != passVal
                                    }}
                                ></Control.text>
                                {changepass && (
                                    <i class=" iconeye" onClick={() => setChangePass(false)}>
                                        <img src={require('../../assets/images/eye-slash.png')} />
                                    </i>
                                )}
                                {!changepass && (
                                    <i class=" iconeye" onClick={() => setChangePass(true)}>
                                        <img src={require('../../assets/images/eye.png')} />
                                    </i>
                                )}
                            </div>
                            <Errors
                                model="user.passwordConfirmation"
                                errors={{
                                    confirmPasswordNew,
                                    invalidPass,
                                }}
                            />
                            {error && (
                                <p
                                    style={{
                                        color: 'red',
                                        display: 'flex',
                                        'align-items': 'flex-start',
                                    }}
                                >
                                    Confirm Password doesn't match with New Password
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="updateBtn">
                        <button type="submit">Update Password</button>
                    </div>
                </LocalForm>
            </div>
            <Modal
                open={openCongrModal}
                onClose={() => {
                    setOpenCongrModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="congratespopup">
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Your password has been changed Successfully. You will be redirected to the login screen to login again with a new password.
                        </Typography>

                        {/* <Typography>
              <div className='buttonGroupDelete'>

                <button className="btn btn-primary btn-block okaybutton" onClick={() => { setOpenCongrModal(false) }}>Okay
                </button>
              </div>
            </Typography> */}
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default ChangePassword
